// extracted by mini-css-extract-plugin
export default {"tab":"zaKNA_zaKNA","selected":"_F5Kk__F5Kk"};